module.exports = __webpack_public_path__ + "img/arrow-down.5eca58cb.svg";